// extracted by mini-css-extract-plugin
export default {"container":"HomeWithNoFollows_container__rb07i","title":"HomeWithNoFollows_title__Sz2CZ","body":"HomeWithNoFollows_body__tGkNi"};